import { createGlobalStyle, DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  black: "#2B314F",
  blue: "#5492F2",
  blueSaturated: "#0E94F5",
  orange: "#FFB614"
};

export const Styles = createGlobalStyle`
  * {
    box-sizing: border-box;

    /* &::-webkit-scrollbar {
      width: 6px;
      background-color: #fff;
      border: 1px solid #eee;

      &-thumb {
        background: #c9d2e2; 
      }
    } */
  }

  body, h1, h2, h3, h4, h5, h6 {
    color: #2B314F;
  }
  .woot-widget-bubble.woot-elements--right {
    display: none;
    }
  
  a {
    color: ${props => props.theme.black};

    &:hover {
      color: ${props => props.theme.blue};
    }
  }

  .ant {
    &-btn {
      border-radius: 2em;
      background-color: #fff;
      font-weight: 500;
      color: ${props => props.theme.black};
      border-width: 2px;

      &-primary {
        border-color: ${props => props.theme.orange};

        &:hover, &:active, &:focus {
          color: ${props => props.theme.black};
          border-color: ${props => props.theme.orange};
          background-color: #ffeec7;
        }
      }
    }

    &-checkbox-wrapper {
      font-size: 13px!important;
      line-height: 15px;
      color: #8F9091;

      .ant-checkbox {
        margin-right: 0.2rem;
      }
    }

    &-select {
      &-selector {
        border-color: #CBCBCB!important;
        border-radius: 4px!important;
        height: auto!important;
      }

      &-selection-item {
        margin: 4px 0 3px;
        line-height: 1.5em!important;
        font-weight: 500;
        white-space: pre-wrap;

        &:after {
          display: none!important;
        }
      }

      &-arrow svg {
        fill: ${props => props.theme.blue};
      }
    }

    &-popover-buttons {
      button {
        border-width: 1px;
      }
    }

    &-alert {
      border-radius: 5px;
    }

    &-message {
      z-index: 1023;
    }
  }
`;
